








































import Vue from 'vue';
import Component from 'vue-class-component';
import MembershipCard from '@/components/Shared/MembershipCard.vue';
import CollaborationCertificate from '@/components/certificates/CollaborationCertificate.vue';
import {certificatesModule, certificatesState, userModule, userState} from '@/utils/store-acessor';
import {UserModel} from '@/models/user.model';
import {CertificateModel} from '@/models/certificate.model';

@Component({
  components: {
    MembershipCard,
    CollaborationCertificate
  }
})
export default class ProfileAchievements extends Vue {
  @userModule.Getter('user') user!: UserModel;
  @certificatesModule.Getter('certificates') certificates!: CertificateModel[];
  tab = [];

  async mounted() {
    await userState.fetchUser();
    if (!!this.user?.confirmed_at) {
      certificatesState.fetchAll();
    }
  }
}
